const sportClassesFAQ = [
  {
    id: 1,
    question: "کدام پکیج مناسب من است؟",
    answer: [
      "1) اگر هدف شما ، تناسب اندام، بالا بردن آمادگی جسمانی و تقویت عضلات است \n2) از سلامت کامل برخوردارید\n3) سابقه تمرینی دارید، کلاس بدنسازی پیشرفته، می‌تواند کلاس مناسبی برای شما باشد \nاگر سابقه تمرینی ندارید یا دچار آسیب های کوچک، بعضا به دلیل ضعف عضلانی هستید، کلاس بدنسازی مبتدی می‌تواند کلاس مناسبی برای شما باشد.",
      "اگر آسیب جدی دارید(کمر درد، زانو درد، گردن درد و ...) تحت نظر پزشک متخصص و با تایید پزشک، پیلاتس می‌تواند کلاس مناسبی برای شما باشد.",
      "اگر سابقه تمرین ندارید و هدف شما از تمرین سلامت و هماهنگی جسم و ذهن، افزایش انعطاف و تمرکز است، یوگا می‌تواند کلاس مناسبی برای شما باشد.",
    ]
  }
];

export default sportClassesFAQ;